export default __webpack_public_path__ + "9fdc9c3b36916283975d9d2411ecd7d0.svg";